// determines if we should retry a request or not
export function retryCondition(error: Error): boolean {
  // Only retry if it's an axios network error regardless if it is an idempotent request or not
  return error.message.includes("Network Error");
}
